import axios from "axios";
import { ElMessage } from "element-plus";
import store from "../store/index";
import router from "@/router";
import { getLingXiManagerHeaders } from '@/utils/manager';
/**
 * 参考文档 https://github.com/axios/axios
 */
class Request {
    constructor(params) {
        this.baseURL = null;
        this.cancelTokens = {};
        return (this.baseURL = params.baseURL);
    }
    // 获取axios实例的配置
    getInsideConfig() {
        const config = {
            baseURL: this.baseURL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + window.localStorage.getItem("token"),
            },
            timeout: 150000,
            withCredentials: true,
        };
        return config;
    }
    interceptors(instance) {
        // 请求拦截器
        instance.interceptors.request.use((config) => {
            // Do something before request is sent
            return config;
        }, (error) => {
            // Do something with request error
            return Promise.reject(error);
        });
        // 响应拦截器
        instance.interceptors.response.use((res) => {
            if (res.data.code === 401) {
                localStorage.removeItem("token");
                store.commit("setToken", "");
                store.commit("setLoginStatus", { status: true });
                store.commit('setUserInfo', {});
            }
            switch (res.data.code) {
                case 0:
                case 200:
                    break;
                case 400:
                    ElMessage.warning({ showClose: true, message: res.data.msg });
                    break;
                // 会员
                case 403:
                    break;
                // 身份过期
                case 401:
                    break;
                // 数据不存在
                case 404:
                    break;
                // 未绑定
                case 1011:
                    break;
                // 设备未授权
                case 1401:
                    sessionStorage.removeItem('deviceInfo');
                    router.replace("/device-401");
                    break;
                default:
                    ElMessage.error({ showClose: true, message: res.data.msg });
                    break;
            }
            return res.data;
        }, (error) => {
            return Promise.reject(error);
        });
    }
    // 创建实例
    request(options, requestKey) {
        const instance = axios.create();
        const newOptions = { ...this.getInsideConfig(), ...options };
        // 创建一个取消令牌
        const source = axios.CancelToken.source();
        newOptions.cancelToken = source.token;
        // 存储取消令牌以便于取消请求
        if (requestKey) {
            this.cancelTokens[requestKey] = source.cancel;
        }
        this.interceptors(instance);
        return instance(newOptions);
    }
    // 取消请求方法
    cancelRequest(requestKey) {
        if (this.cancelTokens[requestKey]) {
            this.cancelTokens[requestKey]("请求已取消");
            delete this.cancelTokens[requestKey]; // 移除取消的请求
        }
    }
    get(url, data, config = {}, requestKey) {
        const options = Object.assign({
            method: "get",
            url: url,
            params: data,
            headers: Object.assign(getLingXiManagerHeaders(), {
                "Content-Type": "application/json",
            }),
        }, config);
        return this.request(options, requestKey);
    }
    post(url, data, requestKey) {
        return this.request({
            method: "post",
            url: url,
            data: JSON.stringify(data),
            headers: Object.assign(getLingXiManagerHeaders(), {
                "Content-Type": "application/json",
            }),
        }, requestKey);
    }
    put(url, data, requestKey) {
        return this.request({
            method: "put",
            url: url,
            data: JSON.stringify(data),
            headers: Object.assign(getLingXiManagerHeaders(), {
                "Content-Type": "application/json",
            }),
        }, requestKey);
    }
    delete(url, data, requestKey) {
        return this.request({
            method: "delete",
            url: url,
            data: JSON.stringify(data),
            headers: getLingXiManagerHeaders(),
        }, requestKey);
    }
}
import config_data from "./config";
const request = new Request({
    baseURL: config_data.baseURL,
});
export default request;
